import { FeedbackStatus } from '@/models/feedback.model';
import { TFunction } from 'react-i18next';

const STATUS_OPTIONS = [
  FeedbackStatus.NEW,
  FeedbackStatus.CONVERTED_TO_ORDER,
  FeedbackStatus.CONSULTATION,
  FeedbackStatus.NO_RESPONSE,
  FeedbackStatus.CANCELLED,
] as const;

export const getStatusTypeOptions = (t: TFunction) =>
  STATUS_OPTIONS.map((status) => ({
    label: t(`status_${status}`),
    value: status,
  }));
